import React, { useEffect, useState } from "react";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import StatsSection from "../components/StatsSection";
import { Link } from "react-router-dom";
import PdfPreviewModal from "../components/PreviewModal";

const HomePage = () => {
  const [showIsoPdf, setShowIsoPdf] = useState(false);

  useEffect(() => {
    const swiper = new Swiper(".h3-partner_slider", {
      slidesPerView: 2,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 3, spaceBetween: 30 },
        992: { slidesPerView: 5, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);

  const IsoBadge = () => (
    <img
      src="/assets/img/iso-2015.png"
      alt="ISO 9001:2015 Certified"
      onClick={() => setShowIsoPdf(true)}
      className="fixed top-0 right-14 sm:right-44 xl:right-64 xl:top-0 2xl:right-0 z-50 w-20 2xl:w-32 cursor-pointer hover:scale-105 transition-transform"
    />
  );

  return (
    <main>
      <section className="relative overflow-hidden pt-20 lg:pt-[160px] pb-20 lg:pb-28 max-md:pt-[120px]">
         <IsoBadge />

        {/* Background Pattern */}
        <div className="pattern-bg absolute inset-0 opacity-50" />
        {/* Gradient Blobs */}
        <div className="absolute -left-40 -top-40 h-96 w-96 rounded-full bg-[#1AAD9D]/10 blur-3xl" />
        <div className="absolute -bottom-40 -right-40 h-96 w-96 rounded-full bg-[#1AAD9D]/10 blur-3xl" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">

            {/* Left Content */}
            <div className="text-center lg:text-left">

              {/* Badge */}
              <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-[#1AAD9D50] bg-[#F4FFFE] px-4 py-2" data-aos="fade-down">
                <span className="relative flex h-2 w-2">

                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#1AAD9D] opacity-75" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-[#1AAD9D]" />
                </span>
                <span className="text-sm font-medium text-[#1AAD9D]">
                  Saayaa: OPD and Wellness Platform
                </span>
              </div>
              {/* Heading */}
              <h1 className="font-display text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl lg:text-5xl" data-aos="fade-up" data-aos-delay={100}>
                <span className="gradient-text">Healthcare That Stays</span> <br />
                <span className="mt-2 block"> With You — Every Day</span>
              </h1>
              {/* Description */}
              <p className="mx-auto mt-6 max-w-xl text-lg text-gray-600 lg:mx-0" data-aos="fade-up" data-aos-delay={200}>
                Saayaa brings you smart OPD & wellness plans designed to make healthcare affordable, accessible, and stress-free for you and your family.
              </p>
              {/* CTA Buttons */}
              <div className="mt-8 flex flex-col justify-center gap-4 sm:flex-row lg:justify-start">
                <a
                  href="#services"  data-aos="fade-up" data-aos-delay={300}
                  className="inline-flex items-center justify-center gap-2 rounded-xl btn-gradient px-8 py-4 font-semibold text-white transition-all"
                >
                  View Services
                </a>
                <a
                  href="/plans"  data-aos="fade-up" data-aos-delay={400}
                  className="inline-flex items-center justify-center gap-2 rounded-xl border-2 border-gray-200 bg-white px-8 py-4 font-semibold text-gray-900 transition-all hover:border-gray-300 hover:bg-gray-50"
                >
                  View Plans
                </a>
                <a
                  href="/preview-plan" target="_blank" data-aos="fade-up" data-aos-delay={400}
                  className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#5dd2c4] px-8 py-4 font-semibold text-white transition-all"
                >
                  Get Trial
                </a>
              </div>
              {/* Trust Badges */}
              <div className="mt-10 flex flex-wrap items-center justify-center gap-6 lg:justify-start"  data-aos="fade-up" data-aos-delay={500}>
                <div className="flex items-center gap-2">
                  <div className="flex -space-x-2">

                    <img
                      className="h-8 w-8 rounded-full ring-2 ring-white"
                      src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop"
                      alt=""
                    />
                    <img
                      className="h-8 w-8 rounded-full ring-2 ring-white"
                      src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop"
                      alt=""
                    />
                    <img
                      className="h-8 w-8 rounded-full ring-2 ring-white"
                      src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop"
                      alt=""
                    />
                    <img
                      className="h-8 w-8 rounded-full ring-2 ring-white"
                      src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop"
                      alt=""
                    />
                  </div>
                  <span className="text-sm text-gray-600">

                    <strong className="text-gray-900 mr-1">
                      200+
                    </strong>
                    Doctor's Available
                  </span>
                </div>
                <div className="flex items-center gap-1">

                  <svg
                    className="h-5 w-5 text-accent-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                  </svg>
                  <span className="text-sm text-gray-600">

                    <strong className="text-gray-900 mr-1">
                      4.9
                    </strong>
                    Average Rating
                  </span>
                </div>
              </div>
            </div>
            {/* Right Side - Featured Course Cards Stack */}
            <div className="relative hidden lg:block" data-aos="fade-left">

              {/* Main Card */}
              
              <div className="relative mt-20 z-20 rounded-2xl border border-gray-200 bg-white p-6 shadow-xl">
                <div className="aspect-video overflow-hidden rounded-xl">

                  <img
                    src="assets/img/hero.jpg"
                    alt="Featured course"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="mt-4">
                  <div className="flex items-center gap-2">

                    <span className="rounded-full bg-[#F4FFFE] px-2.5 py-1 text-xs font-medium text-[#1AAD9D]">
                      Sponsored
                    </span>
                  </div>
                  <h3 className="mt-2 font-display text-lg font-semibold text-gray-900">
                    Full Body Checkup: Extensive
                  </h3>
                  <div className="mt-3 flex items-center justify-between">
                    <div className="flex items-center gap-2">

                      <img
                        src="https://etimg.etb2bimg.com/photo/91966201.cms"
                        alt="Instructor"
                        className="h-8 w-8 rounded-full border-[1px] border-[#00000020]"
                      />
                      <span className="text-sm text-gray-600">
                        Thyrocare
                      </span>
                    </div>
                    <div className="flex items-center gap-1">
                      <span className="text-sm font-medium text-gray-900">
                        Booking Id: B420000XB62
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {/* Background Cards */}
              <div className="absolute -right-4 top-8 z-30 w-72 rounded-2xl border border-gray-200 bg-white/80 p-4 shadow-lg backdrop-blur/80 animate-float1">
                <div className="flex items-center gap-3">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100">
                    <svg
                      className="h-6 w-6 text-primary-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-900">
                      Appointment Confirmed
                    </p>
                    <p className="text-xs text-gray-500">
                      {new Date(Date.now() + 172800000).toLocaleString("en-IN", { hour: "2-digit", minute: "2-digit", day: "numeric", month: "short" })}
                    </p>
                  </div>
                </div>
              </div>
              <div className="absolute -left-8 top-24 z-30 w-64 rounded-2xl border border-gray-200 bg-white/80 p-4 shadow-lg backdrop-blur/80 animate-float">
                <div className="flex items-center gap-3">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#eadcff]">
                    <svg
                      className="h-6 w-6 text-[#7F53C1]"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#7F53C1"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                      />
                    </svg>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-900">
                      Cashless OPD
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Stats Bar */}
          {/* <div className="mt-[100px] grid grid-cols-2 gap-8 rounded-2xl border border-gray-200 bg-white p-8 shadow-sm lg:grid-cols-4">
            <div className="text-center">
              <div className="font-display text-3xl font-bold text-gray-900 lg:text-4xl">
                500+
              </div>
              <div className="mt-1 text-sm text-gray-600">
                Doctors
              </div>
            </div>
            <div className="text-center">
              <div className="font-display text-3xl font-bold text-gray-900 lg:text-4xl">
                220+
              </div>
              <div className="mt-1 text-sm text-gray-600">
                Hospitals
              </div>
            </div>
            <div className="text-center">
              <div className="font-display text-3xl font-bold text-gray-900 lg:text-4xl">
                110+
              </div>
              <div className="mt-1 text-sm text-gray-600">
                Corporates & Associations
              </div>
            </div>
            <div className="text-center">
              <div className="font-display text-3xl font-bold text-gray-900 lg:text-4xl">
                5000+
              </div>
              <div className="mt-1 text-sm text-gray-600">
                Customers
              </div>
            </div>
          </div> */}
          <StatsSection />

          <center className="min-md:px-[200px] mt-[80px]">
            <div className="swiper h3-partner_slider mt-11 overflow-hidden">
              <div className="swiper-wrapper">
                <div className="swiper-slide" data-aos="fade">
                  <img src="assets/img/partner_logo/1.svg" alt="" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={100}
                >
                  <img src="assets/img/partner_logo/2.svg" alt="" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={200}
                >
                  <img src="assets/img/partner_logo/4.svg" alt="" />
                </div>
                <div
                  className="swiper-slide"  data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/img/partner_logo/practo.png" alt="" width={130} height={50} className="mt-3"/>
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={300}
                >
                  <img src="assets/img/partner_logo/5.svg" alt="" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={400}
                >
                  <img src="assets/img/partner_logo/6.svg" alt="" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/img/partner_logo/7.svg" alt="" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/img/partner_logo/8.svg" alt="" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/img/partner_logo/9.png" alt="" className="h-[60px]" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/img/partner_logo/10.png" alt="" className="h-[60px]" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/img/partner_logo/11.png" alt="" className="h-[60px]" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/img/partner_logo/12.png" alt="" className="h-[60px]" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/img/partner_logo/13.svg" alt="" className="h-[60px]" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/img/partner_logo/14.png" alt="" className="h-[60px]" />
                </div>
              </div>
            </div>
          </center>

        </div>
      </section>
      <section className="bg-gray-100/50 py-20 lg:py-28" id="services">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 max-md:text-center">

          {/* Section Header */}
          <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
            <div>
              {/* Badge */}
              <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-[#1AAD9D50] bg-[#F4FFFE] px-4 py-2"  data-aos="fade-down">
                <span className="relative flex h-2 w-2">

                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#1AAD9D] opacity-75" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-[#1AAD9D]" />
                </span>
                <span className="text-sm font-medium text-[#1AAD9D]">
                  Our Services
                </span>
              </div>
              <h2 className="font-display text-3xl font-bold text-gray-900 lg:text-4xl"  data-aos="fade-up">
                Browse our Services
              </h2>
              <p className="mt-2 text-gray-600"  data-aos="fade-up">
                Say goodbye to out-of-pocket medical expenses
              </p>
            </div>
          </div>
          {/* Categories Grid */}
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">

            <a href="/service-benefits#tele-consultation" data-aos="fade-up"
              className="card-hover group rounded-2xl border border-gray-200 bg-white overflow-hidden"
            >
              <div className="p-6">
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-primary-100">
                  <img src="assets/icons/tele-consult.svg" alt="Tele Consult" />
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold text-gray-900 group-hover:text-primary-600">
                  Tele Consultation
                </h3>
                <p className="mt-2 line-clamp-3 text-sm text-gray-600">

                  Consult doctors remotely through phone or digital channels without visiting a clinic.
                </p>
              </div>
              <img src="assets/img/tele-consult.png" alt="Tele Consultation" />
            </a>
            <a href="/service-benefits#diagnostics"  data-aos="fade-up" data-aos-delay={100}
              className="card-hover group rounded-2xl border border-gray-200 bg-white overflow-hidden"
            >
              <div className="p-6">
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-accent-100">
                  <img src="assets/icons/diagnostics.svg" alt="Diagnostics" />
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold text-gray-900 group-hover:text-primary-600">
                  Diagnostics
                </h3>
                <p className="mt-2 line-clamp-3 text-sm text-gray-600">

                  Access lab tests and health checkups for accurate medical diagnosis.
                </p>
              </div>
              <img src="assets/img/diagnostics.png" alt="Diagnostics" />
            </a>
            <a href="/service-benefits#consultation"   data-aos="fade-up" data-aos-delay={200} className="card-hover group rounded-2xl border border-gray-200 bg-white overflow-hidden">
              <div className="p-6">
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-pink-100">
                  <img src="assets/icons/consultation.svg" alt="Consultation" />
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold text-gray-900 group-hover:text-primary-600">
                  Consultation
                </h3>
                <p className="mt-2 line-clamp-3 text-sm text-gray-600">

                 Book in-person doctor visits for physical examination and treatment with healthcare professionals.
                </p>
              </div>
              <img src="assets/img/consultation.png" alt="Consultation" />
            </a>
            <a href="/service-benefits#mental-wellness"  data-aos="fade-up" data-aos-delay={300} className="card-hover group rounded-2xl border border-gray-200 bg-white overflow-hidden">
              <div className="p-6">
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-cyan-100">
                  <img src="assets/icons/mental-wellness.svg" alt="Mental Wellness" />
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold text-gray-900 group-hover:text-primary-600">
                  Mental Wellness
                </h3>
                <p className="mt-2 line-clamp-3 text-sm text-gray-600">

                  Get professional support to manage stress, anxiety, and regain emotional control.
                </p>
              </div>
              <img src="assets/img/mental-wellness.png" alt="Mental Wellness" />
            </a>
            <a href="/service-benefits#vitals"  data-aos="fade-up" className="card-hover group rounded-2xl border border-gray-200 bg-white overflow-hidden">
              <div className="p-6">
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-violet-100">
                  <img src="assets/icons/face-scan.svg" alt="Face Scan" />
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold text-gray-900 group-hover:text-primary-600">
                  Vitals via Face Scan
                </h3>
                <p className="mt-2 line-clamp-3 text-sm text-gray-600">

                  Check key health vitals instantly using AI-powered facial scanning technology.
                </p>
              </div>
              <img src="assets/img/face-scan.png" alt="Vitals via Face Scan" />
            </a>
            <a href="/service-benefits#chat"  data-aos="fade-up" data-aos-delay={100} className="card-hover group rounded-2xl border border-gray-200 bg-white overflow-hidden">
              <div className="p-6">
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-amber-100">
                  <svg
                    className="h-7 w-7 text-amber-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
                    ></path>
                  </svg>
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold text-gray-900 group-hover:text-primary-600">
                  Chat With Experts
                </h3>
                <p className="mt-2 line-clamp-3 text-sm text-gray-600">

                  Get instant medical advice through real-time chat with healthcare professionals.
                </p>
              </div>
              <img src="assets/img/chats.png" alt="Chat With Experts" />
            </a>
            <a href="/service-benefits#video-consultation"  data-aos="fade-up" data-aos-delay={200} className="card-hover group rounded-2xl border border-gray-200 bg-white overflow-hidden">
              <div className="p-6">
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-red-100">
                  <img src="assets/icons/video-consult.svg" alt="Video Consult" />
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold text-gray-900 group-hover:text-primary-600">
                  Video Consultation
                </h3>
                <p className="mt-2 line-clamp-3 text-sm text-gray-600">

                  Connect face-to-face with doctors through secure video calls from anywhere, anytime easily.
                </p>
              </div>
              <img src="assets/img/video-consult.png" alt="Video Consultation" />
            </a>
            <a href="/service-benefits#naturopathy"  data-aos="fade-up" data-aos-delay={300} className="card-hover group rounded-2xl border border-gray-200 bg-white overflow-hidden">
              <div className="p-6">
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-emerald-100">
                  <img src="assets/icons/naturopathy.svg" alt="Naturopathy" />
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold text-gray-900 group-hover:text-primary-600">
                  Naturopathy
                </h3>
                <p className="mt-2 line-clamp-3 text-sm text-gray-600">

                  Holistic treatments focused on natural healing and lifestyle correction.
                </p>
              </div>
              <img src="assets/img/naturopathy.png" alt="Naturopathy" />
            </a>
          </div>

          <div className="w-full flex justify-center">
            <a
              href="/plans"  data-aos="fade-up"
              className="inline-flex items-center gap-2 font-semibold text-black transition-all hover:text-[#7F53C1] mt-[80px] justify-center"
            >
              Find 10+ more services
              <svg
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                />
              </svg>
            </a>
          </div>
        </div>
      </section>
      <section className="py-[100px]" id="aboutus">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">

            {/* Left Content */}
            <div>

              {/* Badge */}
              <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-[#1AAD9D50] bg-[#F4FFFE] px-4 py-2"  data-aos="fade-down">
                <span className="relative flex h-2 w-2">

                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#1AAD9D] opacity-75" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-[#1AAD9D]" />
                </span>
                <span className="text-sm font-medium text-[#1AAD9D]">
                  About Us
                </span>
              </div>
              <h2 className="mt-4 font-display text-3xl font-bold text-gray-900 lg:text-4xl"  data-aos="fade-up" data-aos-delay={100}>
                Because Your Health Deserves
                <span className="gradient-text ml-2">Everyday Protection</span>
              </h2>
              <p className="mt-4 text-lg text-gray-600" data-aos="fade-up" data-aos-delay={200}>
                At Saayaa, we believe healthcare shouldn’t start only when you fall sick — it should support you every single day.
              </p>
              <p className="mt-4 text-lg text-gray-600"  data-aos="fade-up" data-aos-delay={300}>
                We specialize in OPD and wellness plans that help individuals and families manage everyday medical expenses, preventive care, and overall well-being without financial stress.
              </p>
              <h3 className="mt-4 text-lg text-black font-semibold" data-aos="fade-up" data-aos-delay={200}>
                Our goal is simple:
              </h3>
              <ul className="mt-4 text-lg text-gray-600" data-aos="fade-up" data-aos-delay={300}>
                <li>👉 Make quality healthcare affordable</li>
                <li>👉 Make preventive care accessible</li>
                <li>👉 Help people live healthier, worry-free lives</li>
              </ul>

              <a
                href="/plans"  data-aos="fade-up" data-aos-delay={400}
                className="inline-flex items-center justify-center gap-2 rounded-xl btn-gradient px-8 py-4 font-semibold text-white mt-6 transition-all"
              >
                View Our Plans
              </a>

            </div>
            {/* Right Content - Visual */}
            <div className="relative" data-aos="fade">
              <img src="assets/img/about.jpg" className="rounded-[16px]" alt="" />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-gray-100/50 py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

          {/* Section Header */}
          <div className="text-center">

            {/* Badge */}
            <div className="inline-flex items-center gap-2 rounded-full border border-[#1AAD9D50] bg-[#F4FFFE] px-4 py-2" data-aos="fade-down">
              <span className="relative flex h-2 w-2">

                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#1AAD9D] opacity-75" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-[#1AAD9D]" />
              </span>
              <span className="text-sm font-medium text-[#1AAD9D]">
                Success Stories
              </span>
            </div>
            <h2 className="mt-4 font-display text-3xl font-bold text-gray-900 lg:text-4xl" data-aos="fade-up" data-aos-delay={100}>
              What Our Patient's Say
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-gray-600" data-aos="fade-up" data-aos-delay={200}>
              Join thousands who’ve made healthcare simpler with Saayaa.
            </p>
          </div>
          {/* Testimonials Grid - Masonry-like layout */}
          <div className="mt-12 columns-1 gap-6 space-y-6 md:columns-2 lg:columns-3">
            <div data-aos="fade-up" className="break-inside-avoid rounded-2xl border border-gray-200 bg-white p-6 md:col-span-2">
              {/* Stars */}
              <div className="flex gap-1">

                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
              </div>
              {/* Content */}
              <p className="mt-4 text-gray-700">
                "After buying Saayaa plans, I no longer worry about frequent doctor visits or diagnostic costs."
              </p>
              {/* Course Badge */}
              <div className="mt-4 inline-flex items-center gap-2 rounded-lg bg-[#F4FFFE] px-3 py-1.5 text-sm text-[#1AAD9D]">
                <i class="fa-solid fa-face-grin-hearts"></i>
                Love their instant support
              </div>
              {/* Author */}
              <div className="mt-5 flex items-center gap-3">
                <div>
                  <div className="font-semibold text-gray-900">
                    Rahul Sharma
                  </div>
                  <div className="text-sm text-gray-600">
                    Mumbai, Maharastra
                  </div>
                </div>
              </div>
            </div>
            <div data-aos="fade-up" className="break-inside-avoid rounded-2xl border border-gray-200 bg-white p-6 ">
              {/* Stars */}
              <div className="flex gap-1">

                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
              </div>
              {/* Content */}
              <p className="mt-4 text-gray-700">
                "Their wellness are truly valuable. Regular health checkups & consultations have become so convenient and affordable"
              </p>
              {/* Course Badge */}
              <div className="mt-4 inline-flex items-center gap-2 rounded-lg bg-[#F4FFFE] px-3 py-1.5 text-sm text-[#1AAD9D]">
                <i class="fa-solid fa-stethoscope"></i>
                Healthcare made stress-free
              </div>
              {/* Author */}
              <div className="mt-5 flex items-center gap-3">
                <div>
                  <div className="font-semibold text-gray-900">

                    Neha Kapoor
                  </div>
                  <div className="text-sm text-gray-600">

                    New Delhi, Delhi
                  </div>
                </div>
              </div>
            </div>
            <div data-aos="fade-up" data-aos-delay={100} className="break-inside-avoid rounded-2xl border border-gray-200 bg-white p-6 ">
              {/* Stars */}
              <div className="flex gap-1">

                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
              </div>
              {/* Content */}
              <p className="mt-4 text-gray-700">
                "As a working professional, I needed a plan that covers everyday medical needs. Saayaa is exactly what I was looking for."
              </p>
              {/* Course Badge */}
              <div className="mt-4 inline-flex items-center gap-2 rounded-lg bg-[#F4FFFE] px-3 py-1.5 text-sm text-[#1AAD9D]">
                <i class="fa-solid fa-indian-rupee-sign"></i>
                Saves me money every visit
              </div>
              {/* Author */}
              <div className="mt-5 flex items-center gap-3">
                <div>
                  <div className="font-semibold text-gray-900">

                    Amit Verma
                  </div>
                  <div className="text-sm text-gray-600">

                    Ghaziabad, Uttar Pradesh
                  </div>
                </div>
              </div>
            </div>
            <div data-aos="fade-up" data-aos-delay={100} className="break-inside-avoid rounded-2xl border border-gray-200 bg-white p-6 ">
              {/* Stars */}
              <div className="flex gap-1">

                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
              </div>
              {/* Content */}
              <p className="mt-4 text-gray-700">
                "The network of doctors and labs is excellent. I get quality care without the stress of high out-of-pocket expenses."
              </p>
              {/* Course Badge */}
              <div className="mt-4 inline-flex items-center gap-2 rounded-lg bg-[#F4FFFE] px-3 py-1.5 text-sm text-[#1AAD9D]">
                <i class="fa-solid fa-heart-circle-bolt"></i>
                Always quick and reliable
              </div>
              {/* Author */}
              <div className="mt-5 flex items-center gap-3">
                <div>
                  <div className="font-semibold text-gray-900">

                    Priya Mehta
                  </div>
                  <div className="text-sm text-gray-600">

                    Surat, Gujarat
                  </div>
                </div>
              </div>
            </div>
            <div data-aos="fade-up" data-aos-delay={200} className="break-inside-avoid rounded-2xl border border-gray-200 bg-white p-6 ">
              {/* Stars */}
              <div className="flex gap-1">

                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
              </div>
              {/* Content */}
              <p className="mt-4 text-gray-700">
                "Saayaa is not just a healthcare plan — it’s complete peace of mind for me and my family."
              </p>
              {/* Course Badge */}
              <div className="mt-4 inline-flex items-center gap-2 rounded-lg bg-[#F4FFFE] px-3 py-1.5 text-sm text-[#1AAD9D]">
                <i class="fa-solid fa-hand-holding-medical"></i>
                Perfect for my family needs
              </div>
              {/* Author */}
              <div className="mt-5 flex items-center gap-3">
                <div>
                  <div className="font-semibold text-gray-900">

                    Rakesh Gupta
                  </div>
                  <div className="text-sm text-gray-600">
                    Lucknow, Uttar Pradesh
                  </div>
                </div>
              </div>
            </div>
            <div data-aos="fade-up" data-aos-delay={200} className="break-inside-avoid rounded-2xl border border-gray-200 bg-white p-6 ">
              {/* Stars */}
              <div className="flex gap-1">

                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <svg
                  className="h-5 w-5 text-accent-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
              </div>
              {/* Content */}
              <p className="mt-4 text-gray-700">
                "What I love most is the focus on preventive care. It motivates me to stay healthy rather than just treating illnesses."
              </p>
              {/* Course Badge */}
              <div className="mt-4 inline-flex items-center gap-2 rounded-lg bg-[#F4FFFE] px-3 py-1.5 text-sm text-[#1AAD9D]">
                <i class="fa-solid fa-headset"></i>
                Truly responsive support
              </div>
              {/* Author */}
              <div className="mt-5 flex items-center gap-3">
                <div>
                  <div className="font-semibold text-gray-900">
                    Sneha Arora
                  </div>
                  <div className="text-sm text-gray-600">
                    Gurgaon, Haryana
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="relative overflow-hidden rounded-3xl">

            {/* Background */}
            <div className="gradient-bg absolute inset-0" /> {/* Pattern Overlay */}
            <div className="absolute inset-0 opacity-10">

              <svg
                className="h-full w-full"
                viewBox="0 0 100 100"
                preserveAspectRatio="none"
              >
                <defs>
                  <pattern
                    id="grid"
                    width={10}
                    height={10}
                    patternUnits="userSpaceOnUse"
                  >
                    <path
                      d="M 10 0 L 0 0 0 10"
                      fill="none"
                      stroke="white"
                      strokeWidth="0.5"
                    />
                  </pattern>
                </defs>
                <rect width={100} height={100} fill="url(#grid)" />
              </svg>
            </div>
            {/* Content */}
            <div className="relative px-8 py-16 text-center lg:px-16 lg:py-24">
              <h2 className="mx-auto max-w-3xl font-display text-3xl font-bold text-white lg:text-5xl" data-aos="fade-up">
                Join a growing community prioritizing everyday wellness.
              </h2>
              <p className="mx-auto mt-[24px] text-lg text-white/80"  data-aos="fade-up" data-aos-delay={100}>
                Be among thousands choosing Saayaa for better health protection.
              </p>
              {/* CTA Buttons */}
              <div className="mt-10 flex flex-col justify-center gap-4 sm:flex-row">

                <a
                  href="/plans"  data-aos="fade-up" data-aos-delay={200}
                  className="inline-flex items-center justify-center gap-2 rounded-xl bg-white px-8 py-4 font-semibold text-primary-600 shadow-lg transition-all hover:bg-gray-100"
                >
                  Get Started
                  <svg
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                    />
                  </svg>
                </a>
                <a
                  href="/contact-us"  data-aos="fade-up" data-aos-delay={300}
                  className="inline-flex items-center justify-center gap-2 rounded-xl border-2 border-white/30 px-8 py-4 font-semibold text-white transition-all hover:border-white hover:bg-white/10"
                >
                  Contact Us
                </a>
              </div>
              {/* Trust Indicators */}
              <div className="mt-12 flex flex-wrap items-center justify-center gap-8 text-sm text-white/70">
                <div className="flex items-center gap-2" data-aos="fade">

                  <svg
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  Choose a Plan
                </div>
                <div className="flex items-center gap-2"  data-aos="fade" data-aos-delay={100}>

                  <svg
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  Get Instant Access
                </div>
                <div className="flex items-center gap-2"  data-aos="fade" data-aos-delay={200}>

                  <svg
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  Visit Network Providers
                </div>
                <div className="flex items-center gap-2"  data-aos="fade" data-aos-delay={300}>

                  <svg
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  Enjoy Cashless Benefits
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
       <PdfPreviewModal
        isOpen={showIsoPdf}
        onClose={() => setShowIsoPdf(false)}
        pdfUrl="/assets/pdf/iso-certified.pdf"
        title="ISO 9001:2015 Certification"
      />
    </main>

  );
};

export default HomePage;
